import React from 'react';
import PropTypes from 'prop-types';
import { USER_GROUPS_SOURCES } from '../../stores/Policy/BrowsingRoles/BrowsingRolesStore';

const USER_GROUPS_SOURCE_LABELS = {
    [USER_GROUPS_SOURCES.NONE]: {
        label: 'None',
        text: 'No group synchronization',
    },
    [USER_GROUPS_SOURCES.TAP]: {
        label: 'PPS',
        text: 'Cloud User Sync',
    },
    [USER_GROUPS_SOURCES.SAML]: {
        label: 'SAML/Idp',
        text: 'Group synchronization',
    },
    // alternative text for NONE when user has no access to TAP/SAML
    noGroups: {
        label: 'None',
        text: 'No groups are available to create Browsing Roles',
    },
};

export default function UserGroupSourceLabel({ value }) {
    const { label, text } = USER_GROUPS_SOURCE_LABELS[value || USER_GROUPS_SOURCES.NONE];

    return <span><b>{label}</b> - {text}</span>;
}

UserGroupSourceLabel.propTypes = {
    value: PropTypes.string,
};
